import React, { useState } from "react";
import { X, Bell } from "lucide-react";

function HoaAdminNotification() {
  const [showNotification, setShowNotification] = useState(true);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  return (
    <>
      {showNotification && (
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6 border border-gray-200">
          <div className="flex items-center justify-between p-4">
            <div className="flex items-start gap-3">
              <Bell className="h-5 w-5 text-blue-500 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-blue-600 mb-1">
                  Announcements / News
                </h3>
                <p className="text-sm text-gray-600">
                  Copy about a specific feature or action users should be aware of or take.
                </p>
              </div>
            </div>
            <button
              onClick={handleCloseNotification}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label="Close notification"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default HoaAdminNotification;